// importing react componet
import * as React from 'react';

// dev extreme grid component
import {
    SearchState,
    FilteringState,
    IntegratedFiltering,
    RowDetailState,
    PagingState,
    SortingState,
    CustomPaging,
    IntegratedPaging,
    IntegratedSorting,
} from '@devexpress/dx-react-grid';

// dev extreme paper (like canvas for rendering grid)
import Paper from '@material-ui/core/Paper';

// importing style for inner table 
import { withStyles } from '@material-ui/core/styles';

// dev extreme grid UI
import {
    Grid,
    Table,
    Toolbar,
    SearchPanel,
    TableHeaderRow,
    TableColumnResizing,
    TableFilterRow,
    PagingPanel,
    TableColumnVisibility,
    ColumnChooser,
    TableRowDetail
} from '@devexpress/dx-react-grid-material-ui';

// importing api link 
import * as  apiService from '../../store/apiService';

// custom component
import TableCellwithColors from '../../sharedcomponents/TableCellwithColors';

// columns for grid
import { productionReportsColumns } from './productionReportsColumns'

//  formatting date mm/dd/yyyy
import formatDate from '../../helpers/dateFormat';

// importing sorting helper
import { sortDatebySelection, sortCurrency } from '../../helpers/sortingHelper';

// Defining custom cell for Grid
// ts-ingore user for ignoring ts validation for perticular line

// enabling the functionality for display Header name when hover on column header 
// @ts-ignore
const ColumnHeaderCell = ({ getMessage, column, ...restProps }) => (
    // @ts-ignore
    <TableHeaderRow.Cell
        column={column}
        getMessage={() => column.title}
        {...restProps}
    />
);

// opening new tab in atlas with property number
function handleClickPropNum(args: any) {
    window.open(apiService.atlaslink(args), "_blank")
}

// @ts-ignore
const Cell = ({ value, ...restProps }) => {
    // @ts-ignore
    const { column } = restProps;
    const showColumn = []
    if (column.name === "pos_0_vendor") {
        for (let i = 0; i < restProps.row.pos_length; i++) {
            const randomValue = Math.random();
            const datedisplay = restProps.row[`pos_${i}_date_needed`] !== "" ?
                <div key={randomValue} className="floatleftwithMargin">{formatDate(restProps.row[`pos_${i}_date_needed`])}</div> : ""
            if (restProps.row[`pos_${i}_date_needed`] !== "" &&
                restProps.row[`pos_${i}_outfor_approval`] === "" &&
                restProps.row[`pos_${i}_date_approved`] === "" &&
                restProps.row[`pos_${i}_received`] === "0" &&
                (restProps.row[`pos_${i}_completed`] === "0" || restProps.row[`pos_${i}_completed`] === "")
            ) {
                showColumn.push(
                    <div className="m-b-5 left-float">
                        <div className="redcircle floatleftwithMargin"></div>
                        <div className="floatleftwithMargin">{restProps.row[`pos_${i}_quantity`]} @</div>
                        <div className="floatleftwithMargin">{restProps.row[`pos_${i}_vendor`]}:</div>
                        {datedisplay}
                    </div>
                )
            }
            else if (restProps.row[`pos_${i}_date_needed`] !== "" &&
                restProps.row[`pos_${i}_outfor_approval`] !== "" &&
                restProps.row[`pos_${i}_date_approved`] === "" &&
                restProps.row[`pos_${i}_received`] === "0" &&
                (restProps.row[`pos_${i}_completed`] === "0" || restProps.row[`pos_${i}_completed`] === "")
            ) {
                showColumn.push(
                    <div className="m-b-5 left-float">
                        <div className="bluecircle floatleftwithMargin"></div>
                        <div className="floatleftwithMargin">{restProps.row[`pos_${i}_quantity`]} @</div>
                        <div className="floatleftwithMargin">{restProps.row[`pos_${i}_vendor`]}:</div>
                        {datedisplay}
                    </div>
                )
            }
            else if (restProps.row[`pos_${i}_date_needed`] !== "" &&
                restProps.row[`pos_${i}_outfor_approval`] !== "" &&
                restProps.row[`pos_${i}_date_approved`] !== "" &&
                restProps.row[`pos_${i}_received`] === "0" &&
                (restProps.row[`pos_${i}_completed`] === "0" || restProps.row[`pos_${i}_completed`] === "")
            ) {
                showColumn.push(
                    <div className="m-b-5 left-float">
                        <div className="orangecircle floatleftwithMargin"></div>
                        <div className="floatleftwithMargin">{restProps.row[`pos_${i}_quantity`]} @</div>
                        <div className="floatleftwithMargin">{restProps.row[`pos_${i}_vendor`]}:</div>
                        {datedisplay}
                    </div>

                )
            }
            else if (restProps.row[`pos_${i}_date_needed`] !== "" &&
                restProps.row[`pos_${i}_outfor_approval`] !== "" &&
                restProps.row[`pos_${i}_date_approved`] !== "" &&
                restProps.row[`pos_${i}_received`] === "1" &&
                (restProps.row[`pos_${i}_completed`] === "0" || restProps.row[`pos_${i}_completed`] === "")
            ) {
                showColumn.push(
                    <div className="m-b-5 left-float">
                        <div className="greencircle floatleftwithMargin"></div>
                        <div className="floatleftwithMargin">{restProps.row[`pos_${i}_quantity`]} @</div>
                        <div className="floatleftwithMargin">{restProps.row[`pos_${i}_vendor`]}:</div>
                        {datedisplay}
                    </div>
                )
            }
            else if (restProps.row[`pos_${i}_completed`] === "1") {
                showColumn.push(<div className="empty_active"></div>)
            }
        }
        return <td text-align="center">{showColumn}</td>;
    }
    if (column.name === 'tenants_entered') {
        if (restProps.row.tenants_entered === "0") {
            return <TableCellwithColors color="#d63636" />
        } else if (restProps.row.tenants_entered === "1") {
            return <TableCellwithColors color="#00bb00" />
        }
    }
    if (column.name === 'project_completed') {
        if (restProps.row.project_completed !== "") {
            return <TableCellwithColors color="#00bb00" />
        } else {
            return <TableCellwithColors color="#d63636" />
        }

    }
    
    if (column.name === 'screen_approval') {
        if (restProps.row.screen_approval === "Approved") {
            return <TableCellwithColors color="#00bb00" />
        } else if (restProps.row.screen_approval === "Required") {
            return <TableCellwithColors color="#d63636" />
        } else if (restProps.row.screen_approval === "Pending") {
            return <TableCellwithColors color="#f0e400" />
        } else if (restProps.row.screen_approval === "   Pending") {
            return <TableCellwithColors color="orange" />
        } else if (restProps.row.screen_approval === "Sec Required") {
            return <TableCellwithColors color="blue" />
        }

    }
    if (column.name === 'deposit_rcvd') {
        if (restProps.row.deposit_rcvd === "Paid" || restProps.row.deposit_rcvd === "Yes") {
            return <TableCellwithColors color="#00bb00" />
        } else if (restProps.row.deposit_rcvd === "Not Paid" || restProps.row.deposit_rcvd === "No") {
            return <TableCellwithColors color="#d63636" />
        } else if (restProps.row.deposit_rcvd === "N/A") {
            return <td><div> N/A </div></td>
        }
    }
    if (column.name === 'property_number') {
        return <td><a style={{ color: 'lightblue' }} onClick={() => handleClickPropNum(restProps.row.property_number)}>{restProps.row.property_number}</a></td>
    }
    if (column.name === 'property_name') {
        return <td>
            <div>{restProps.row.property_name}</div>
            <div>{restProps.row.client_name}</div>
        </td>
    }
    if (column.name === "totalRevenue") {
        return <td>
            <div>${formatRevenue(restProps.row.totalRevenue)}</div>
        </td>
    }

    if (column.name === 'status_notes') {
        return <td>
            <div className="word-breakdiv">
                <div className="m-b-5">{restProps.row.status_notes}</div>
                <div>{restProps.row.last_contact_notes}</div>
            </div>
        </td>
    }

    // @ts-ignore
    return <Table.Cell {...restProps}>
        <span title={value}>{value}</span>
    </Table.Cell>
};

// method for formating revenue in local string
const formatRevenue = (value: any) => {
    const tempnumber = value.toString().replace(/[!@#$%^&*]/g, "");
    return parseFloat(tempnumber).toLocaleString(undefined, { minimumFractionDigits: 2 })
}

// custome UI for inner table 
// @ts-ignore
const innerTable = ({ value, ...restProps }) => {
    // @ts-ignore
    const { column } = restProps;
    if (column.name === 'units') {
        if (restProps.row.units !== "" && restProps.row.units !== undefined) {
            return <td text-align="center"><div>{restProps.row.units}</div></td>
        }
    }
    if (column.name === 'sale_date') {
        if (restProps.row.sale_date !== "" && restProps.row.sale_date !== undefined){
            return <td><div>{formatDate(restProps.row.sale_date)}</div></td>
        }
    }
    if (column.name === 'sched_ship_date') {
        if (restProps.row.sched_ship_date !== "" && restProps.row.sched_ship_date !== undefined){
            return <td><div>{formatDate(restProps.row.sched_ship_date)}</div></td>
        }
    }
    if (column.name === 'revenue') {
        return <td><div>${formatRevenue(restProps.row.revenue)}</div></td>
    }
    // @ts-ignore
    return <Table.Cell {...restProps}>
        <span title={value}>{value}</span>
    </Table.Cell>
}

// style for inner talbe
const styles = (theme: any) => ({
    detailContainer: {
        margin: '20px',
    },
    title: {
        color: theme.palette.text.primary,
        fontSize: theme.typography.fontSize,
    },
});

// creting inner table 
const GridDetailContainerBase = ({ row }: { row: any }, { classes }: { classes: any }) => (
    <div>
        <Paper className="papergrid">
            <Grid
                rows={row.push}
                columns={productionReportsColumns.detailColumns}
            >
                <Table
                    columnExtensions={productionReportsColumns.tableDetailColumnExtensions}
                    cellComponent={innerTable}
                />
                <TableHeaderRow />
            </Grid>
        </Paper>
    </div>
);

// inner table
const GridDetailContainer = withStyles(styles, { name: 'ReduxIntegrationDemo' })(GridDetailContainerBase);

// class
class ProductionReportsGrid extends React.Component<any, any> {
    public changeCurrentPage: any;
    public changePageSize: any;

    // initializing constructor
    constructor(props: any) {
        super(props);

        // initializing state
        this.state = {
            route: 'shipping',
            date: '',
            selectedReport: 'shipping',
            selectedFilter: 'All',
            columns: [],
            rows: [],
            sorting: [{ columnName: 'property_number', direction: 'asc' }],
            totalCount: 0,
            pageSizes: [10, 15, 30, 50],
            pageSize: 10,
            tableColumnExtensions: [
                { columnName: 'property_number', align: 'left' },
                { columnName: 'property_name', align: 'center' },
                { columnName: 'client_name', align: 'center' },
                { columnName: 'salesperson', align: 'center' },
                { columnName: 'csm_name', align: 'center' },
                { columnName: 'completed_by', align: 'center' },
                { columnName: 'last_sale_date', align: 'center' },
                { columnName: 'online_upd_expire', align: 'center' },
                { columnName: 'due_date', align: 'center' },
                { columnName: 'pcsUnits', align: 'center' },
                { columnName: 'totalRevenue', align: 'left' },
                { columnName: 'last_sale_date', align: 'center' },
                { columnName: 'kick_off_done', align: 'center' },
                { columnName: 'tenants_entered', align: 'center' },
                { columnName: 'project_completed', align: 'center' },
                { columnName: 'screen_approval', align: 'center' },
                { columnName: 'deposit_rcvd', align: 'center' },
                { columnName: 'status_notes', align: 'center' }
            ],
            integratedSortingColumnExtensions: [
                { columnName: 'last_sale_date', compare: sortDatebySelection },
                { columnName: 'due_date', compare: sortDatebySelection },
                { columnName: 'online_upd_expire', compare: sortDatebySelection },
                { columnName: 'totalRevenue', compare: sortCurrency }
            ],
            filteringColumnExtensions: [
                {
                    columnName: 'status_notes',
                    predicate: (value: any, filter: any, row: any) => {
                        if (filter.value) {
                            return this.StatusNotesPredicate(value, filter, row);
                        } else {
                            return true
                        }
                    },
                },
                {
                    columnName: 'property_name',
                    predicate: (value: any, filter: any, row: any) => {
                        if (filter.value) {
                            return this.PropertNamePredicate(value, filter, row);
                        } else {
                            return true
                        }
                    },
                },
            ],
        };

        this.changeCurrentPage = (currentPage: any) => {
            if (this.props.expandAllStatus) {
                this.props.expandAllCallback()
            }
            this.setState({ currentPage });

        }
        this.changePageSize = (pageSize: any) => {
            if (this.props.expandAllStatus) {
                this.props.expandAllCallback()
            }
            this.setState({ pageSize });
        }
    }
    public StatusNotesPredicate = (value: any, filter: any, row: any) => {
        return String(row.status_notes.toLowerCase()).indexOf(String(filter.value.toLowerCase())) !== -1 ||
            String(row.last_contact_notes.toLowerCase()).indexOf(String(filter.value.toLowerCase())) !== -1 
    }

    public PropertNamePredicate = (value: any, filter: any, row: any) => {
        return String(row.property_name.toLowerCase()).indexOf(String(filter.value.toLowerCase())) !== -1 ||
            String(row.client_name.toLowerCase()).indexOf(String(filter.value.toLowerCase())) !== -1
    }

    // rendering UI
    public render() {
        const {
            filteringColumnExtensions,
            currentPage,
            pageSize,
            sorting,
            integratedSortingColumnExtensions,
            totalCount,
            tableColumnExtensions,
            pageSizes
        } = this.state;
        return (
            <div>
                {/* main grid */}
                <Paper className="papergrid" id={this.props.tablecolor} style={{ position: 'relative' }}>
                    <Grid
                        rows={this.props.rows}
                        columns={this.props.columns}
                    >
                        <SearchState defaultValue="" />
                        <FilteringState defaultFilters={[]}
                            columnExtensions={[
                                { columnName: 'tenants_entered', filteringEnabled: false },
                                { columnName: 'project_completed', filteringEnabled: false },
                                { columnName: 'screen_approval', filteringEnabled: false },
                                { columnName: 'deposit_rcvd', filteringEnabled: false },
                                { columnName: 'pos_0_vendor', filteringEnabled: false }
                            ]} />
                        <IntegratedFiltering columnExtensions={filteringColumnExtensions}/>

                        <SortingState
                            defaultSorting={sorting}
                            columnExtensions={[
                                { columnName: 'tenants_entered', sortingEnabled: false },
                                { columnName: 'project_completed', sortingEnabled: false },
                                { columnName: 'screen_approval', sortingEnabled: false },
                                { columnName: 'deposit_rcvd', sortingEnabled: false },
                                { columnName: 'pos_0_vendor', sortingEnabled: false },
                                { columnName: 'status_notes', sortingEnabled: false }
                            ]}
                        />
                        <IntegratedSorting
                            columnExtensions={integratedSortingColumnExtensions}
                        />
                        <PagingState
                            defaultCurrentPage={0}
                            currentPage={currentPage}
                            onCurrentPageChange={this.changeCurrentPage}
                            pageSize={pageSize}
                            onPageSizeChange={this.changePageSize}
                        />
                        <CustomPaging
                            totalCount={totalCount}
                        />
                        <IntegratedPaging />
                        <Table
                            columnExtensions={tableColumnExtensions}
                            cellComponent={Cell}
                        />
                        <TableColumnResizing defaultColumnWidths={productionReportsColumns.tableDetailColumnExtensions} />
                        <TableHeaderRow
                            showSortingControls={true}
                            cellComponent={ColumnHeaderCell}
                        />
                        <TableFilterRow
                            showFilterSelector={false}
                        />
                        <RowDetailState />

                        <TableRowDetail
                            contentComponent={GridDetailContainer}
                        />
                        <TableColumnVisibility
                            defaultHiddenColumnNames={['']}
                        />
                        <Toolbar />
                        <SearchPanel />
                        <PagingPanel
                            pageSizes={pageSizes}
                        />
                        <ColumnChooser />
                    </Grid>
                </Paper>
            </div>
        );
    }
}
export default ProductionReportsGrid;



// WEBPACK FOOTER //
// ./src/components/Production/productionReportGrid.tsx